import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import de from "./locales/de.json";

export const supportedLanguages = ["en", "de"] as const;

export type SupportedLanguage = (typeof supportedLanguages)[number];

export const defaultLanguage: SupportedLanguage = "en";

// eslint-disable-next-line import/no-named-as-default-member
i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
  },
  lng: defaultLanguage,
  fallbackLng: defaultLanguage,
  supportedLngs: supportedLanguages as unknown as string[],
  interpolation: {
    // React already escapes values.
    escapeValue: false,
  },
  returnObjects: true,
  react: {
    // The active language is derived synchronously from the URL, so Suspense
    // for translation loading is unnecessary and would add a fallback flash.
    useSuspense: false,
  },
});

export default i18n;
